import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {FieldPath, FieldValues, useFormContext} from "react-hook-form";
import * as React from "react";
import NumberInput from "@/components/forms/NumberInput.tsx";

export default function NumberInputField<T extends FieldValues>(
    {name, title, ...props}:
        { name: FieldPath<T>, title: string } & React.ComponentProps<"input">) {
    const {control} = useFormContext()

    return (
        <FormField control={control} name={name} render={({field}) => (
            <FormItem>
                <FormLabel>{title}</FormLabel>
                <FormControl>
                    <NumberInput {...props} {...field} value={field.value ?? ""}/>
                </FormControl>
                <FormMessage/>
            </FormItem>
        )}/>)

}
